import { Permission } from "@repo/core/constants/permissions";
import { normalizeProposalSituationCode } from "@repo/core/screens/Proposals/rules/analysisQueueRules";
import {
  PROPOSTA_SITUACAO,
  ProposalTypeEnum,
  ProposalTypeValue
} from "@repo/core/services/entities/Proposals";

export const desktopTabs = [
  {
    label: "Dados"
  },
  {
    label: "Análise"
  }
];

const DATA_TAB_ALLOWED_STATUSES = new Set<string>([
  PROPOSTA_SITUACAO.ANALYSIS_MANUAL,
  PROPOSTA_SITUACAO.APPROVED_AUTOMATICALLY,
  PROPOSTA_SITUACAO.APPROVED_MANUALLY,
  PROPOSTA_SITUACAO.REJECTED_AUTOMATICALLY,
  PROPOSTA_SITUACAO.REJECTED_MANUALLY,
  PROPOSTA_SITUACAO.EFFECTIVE,
  PROPOSTA_SITUACAO.MANUAL_ANALYSIS_QUEUE,
  PROPOSTA_SITUACAO.PRE_PROPOSAL_APPROVED,
  PROPOSTA_SITUACAO.PRE_PROPOSAL_REJECTED,
  PROPOSTA_SITUACAO.DOCUMENT_CONFERENCE,
  PROPOSTA_SITUACAO.DATA_CONFERENCE
]);

const ANALYSIS_TAB_ALLOWED_STATUSES = new Set<string>([
  PROPOSTA_SITUACAO.APPROVED_AUTOMATICALLY,
  PROPOSTA_SITUACAO.APPROVED_MANUALLY,
  PROPOSTA_SITUACAO.REJECTED_AUTOMATICALLY,
  PROPOSTA_SITUACAO.REJECTED_MANUALLY,
  PROPOSTA_SITUACAO.PRE_PROPOSAL_APPROVED,
  PROPOSTA_SITUACAO.PRE_PROPOSAL_REJECTED
]);

const DOCUMENTS_TAB_ALLOWED_STATUSES = new Set<string>([
  PROPOSTA_SITUACAO.APPROVED_AUTOMATICALLY,
  PROPOSTA_SITUACAO.APPROVED_MANUALLY,
  PROPOSTA_SITUACAO.REJECTED_AUTOMATICALLY,
  PROPOSTA_SITUACAO.REJECTED_MANUALLY,
  PROPOSTA_SITUACAO.EFFECTIVE,
  PROPOSTA_SITUACAO.PRE_PROPOSAL_APPROVED,
  PROPOSTA_SITUACAO.PRE_PROPOSAL_REJECTED,
  PROPOSTA_SITUACAO.DOCUMENT_CONFERENCE,
  PROPOSTA_SITUACAO.DATA_CONFERENCE
]);

export const canViewProposalDataTab = (
  statusCode?: string,
  permissions: string[] = []
) =>
  DATA_TAB_ALLOWED_STATUSES.has(normalizeProposalSituationCode(statusCode)) &&
  permissions.includes(Permission.CRT_WEB_ATE_CON_FILA_ANALISE);

export const canViewProposalAnalysisItems = (
  statusCode?: string,
  permissions: string[] = []
) =>
  ANALYSIS_TAB_ALLOWED_STATUSES.has(
    normalizeProposalSituationCode(statusCode)
  ) && permissions.includes(Permission.CRT_WEB_ATE_CON_ITENS_ANALISE);

export const canViewProposalDocuments = (
  statusCode?: string,
  permissions: string[] = []
) =>
  DOCUMENTS_TAB_ALLOWED_STATUSES.has(
    normalizeProposalSituationCode(statusCode)
  ) && permissions.includes(Permission.CRT_WEB_ATE_CON_FILA_ANALISE_DOC);

export const canViewProposalLimits = (
  statusCode?: string,
  proposalType?: ProposalTypeValue
) => {
  const normalizedStatusCode = normalizeProposalSituationCode(statusCode);

  if (normalizedStatusCode === PROPOSTA_SITUACAO.APPROVED_MANUALLY) {
    return true;
  }

  if (
    normalizedStatusCode === PROPOSTA_SITUACAO.APPROVED_AUTOMATICALLY ||
    normalizedStatusCode === PROPOSTA_SITUACAO.EFFECTIVE
  ) {
    return proposalType === ProposalTypeEnum.AMBOS;
  }

  return false;
};

export const mobileTabs = [
  {
    label: "Dados"
  },
  {
    label: "Análise"
  },
  {
    label: "Documentos"
  }
];

export const getProposalViewInfoTabs = (
  isMobile: boolean,
  showDataTab: boolean,
  showDocumentsTab: boolean
) => {
  const tabs = isMobile ? mobileTabs : desktopTabs;

  return tabs.filter((tab) => {
    if (tab.label === "Dados") {
      return showDataTab;
    }

    if (tab.label === "Documentos") {
      return showDocumentsTab;
    }

    return true;
  });
};
